import { OptimisticMessage } from 'widget_main/store/types';
import {
  MessageCallbackResponse,
  SendMessageParameters,
} from 'core_main/sdk/send_message/types';
import { Attachment } from './MessageThreadInput/types';

export const createOptimisticMessage = (
  sendMessagePayload: SendMessageParameters,
): OptimisticMessage => {
  const {
    body,
    payload,
    attachments,
    lastDeflection,
    isInAssistantMode,
    initAssistantPayload,
    lang,
  } = sendMessagePayload;
  return {
    messageId: String(Date.now()),
    body,
    payload,
    attachments: attachments?.map((attachment: Attachment) => ({
      attachmentId: String(Date.now()),
      file: attachment.file,
      url: attachment.url,
      name: attachment.file.name,
      contentLength: attachment.file.size,
      contentType: attachment.file.type,
    })),
    lastDeflection,
    isInAssistantMode,
    initAssistantPayload,
    lang,
    sentBy: {
      type: 'customer',
    },
  };
};
export const isLastMessageFromCustomer = (
  messages: MessageCallbackResponse[] | null,
) => {
  const lastMessageConvo = messages?.[messages.length - 1];

  return lastMessageConvo?.sentBy?.type === 'customer';
};
